import {z} from "zod";


export const mapSearchFormSchema = z.object({
	name: z.string().optional(),
	corporationName: z.string().optional(),
	jibunAddress: z.string().optional(),
	employeeIds: z.array(z.string()).optional()
});

export type MapSearchFormType = z.infer<typeof mapSearchFormSchema>;

export const mapSearchSchema = z.object({
	name: z.string().optional(),
	corporationName: z.string().optional(),
	jibunAddress: z.string().optional(),
	employeeIds: z.array(z.string()).optional()
});

export type MapSearchType = z.infer<typeof mapSearchSchema>;